import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import App from './App';
import * as serviceWorker from './serviceWorker';
import axios from 'axios';

//Get user id from store if exist if not default to 1
let user = localStorage.getItem("user-info")
let userId = 1;
if (user) {
  userId = parseInt(JSON.parse(localStorage.getItem("user-info")).id)
}

//Adding default params to all requests eg. userId to get sage refresh token
axios.defaults.params =
{
  userId: userId
}

import store from './reduxToolkit'

import { icons } from './assets/icons'

React.icons = icons

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
